import { ConsentWorkflow, FormDefinitionType } from '@/api/dtos';
import ConsentStandardFields from '@/components/consent/ConsentStandardFields';
import ConsentStandardForm from '@/components/consent/ConsentStandardForm';
import SourceDocuments from '@/components/documents/SourceDocuments';
import { useScopedField } from '@ngt/forms-core';
import { GroupedField, ToggleButtonGroup } from '@ngt/opms';
import { FC } from 'react';

const ServicesAustraliaConsentQuestion: FC = () => {
    const { state: { value: workflow } } = useScopedField<ConsentWorkflow>(
        'workflow',
        { value: true },
        false,
        false
    );

    return (
        <GroupedField
            propertyPath="participantAgreedToDisclosureOfInformation"
            component={ToggleButtonGroup}
            disabled={workflow !== ConsentWorkflow.Standard}
        />
    );
};

const ServicesAustraliaConsentStandardForm: FC = () => (
    <ConsentStandardForm
        formDefinitionId={FormDefinitionType.ServicesAustraliaConsentForm}
    >
        <ConsentStandardFields picfTypeName="Services">
            <ServicesAustraliaConsentQuestion />
        </ConsentStandardFields>
        <SourceDocuments />
    </ConsentStandardForm>
);

export default ServicesAustraliaConsentStandardForm;
